<script setup lang="ts">
  import { ScrollAreaCorner, ScrollAreaRoot, ScrollAreaViewport } from 'radix-vue';
  import type { ScrollAreaRootProps } from 'radix-vue';
  import { computed, ref } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import ScrollBar from './ScrollBar.vue';

  const props = defineProps<
    ScrollAreaRootProps & {
      class?: HTMLAttributes['class'];
      disabled?: boolean;
    }
  >();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const scrollView = ref();

  const scrollTo = (options: { x: 'right' | 'left' | number; y?: 'top' | 'bottom' | number }) => {
    if (scrollView.value?.viewportElement) {
      const opts = {
        left: options.x,
        top: options.y,
      };
      if (options.x === 'right') {
        opts.left = scrollView.value.viewportElement.scrollWidth + 40;
      } else if (options.x === 'left') {
        opts.left = 0;
      }

      if (options.y === 'top') {
        opts.top = 0;
      } else if (options.y === 'bottom') {
        opts.top = scrollView.value.viewportElement.scrollHeight + 40;
      }
      scrollView.value?.viewportElement.scrollTo({
        ...opts,
        behavior: 'smooth',
      });
    }
  };

  defineExpose({
    scrollTo,
  });
</script>

<template>
  <ScrollAreaRoot v-bind="delegatedProps" :class="cn('relative overflow-hidden', props.class)">
    <ScrollAreaViewport
      ref="scrollView"
      class="h-full w-full rounded-[inherit] [&>div:first-child]:h-full overflow-auto"
      :style="disabled ? 'overflow: hidden !important' : 'overflow: auto !important'"
    >
      <slot />
    </ScrollAreaViewport>
    <ScrollBar v-if="!disabled" />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
